export const sleep = async (ms) => new Promise((r) => setTimeout(() => r(), ms))

export const getHexColor = (color, theme) =>
  theme.palette === `${color}.main` ? `${color}.main` : color

/**
 * Check if object is empty
 *
 * @param {object} obj Javascript object to check
 * @return {boolean} true if object has no properties, false otherwise
 */
export const isEmpty = (obj) => !Object.getOwnPropertyNames(obj).length
